module.exports = __webpack_public_path__ + "static/media/request_miles_teal.45801c79.svg";